import { Component, OnInit, Input } from '@angular/core';
import { take } from 'rxjs/operators';
import { PicklistService } from '../../../services/picklist/picklist.service';
import { SchemaField, Document, PicklistValue } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';

@Component({
    selector: 'app-picklist-column',
    templateUrl: './picklist-column.component.html',
    styleUrls: ['./picklist-column.component.scss'],
    standalone: false
})
export class PicklistColumnComponent implements OnInit, DynamicColumn {
  _field: SchemaField;
  _document: Document;


  @Input() set field(value: SchemaField) {
    this._field = value;
    if (!!this._document) {
      this.setFieldValue();
    }
  }
  @Input() set document(value: Document) {
    this._document = value;
    if (!!this._field) {
      this.setFieldValue();
    }
  }

  fieldValue: string;

  constructor(private picklistService: PicklistService) {}

  ngOnInit(): void {}

  private setFieldValue(): string {
    const value = this._document?.[this._field.systemName];

    const selectedPicklistItemUId = value;
    if (!selectedPicklistItemUId) {
      this.fieldValue = '';
      return;
    }

    this.picklistService.getPicklistValues(this._field)
    .pipe(take(1))
    .subscribe(picklistValues => {
      const selectedPickListItem = picklistValues?.find(p => p.uId === selectedPicklistItemUId) as PicklistValue;
      this.fieldValue = selectedPickListItem?.value;
    });
  }
}
